async function modalAboutVideo(state, src) {
  if (state === 'show' && window.innerWidth < 768) {
    return window.location.href = src;
  }

  const { default: Modal } = await import('bootstrap/js/dist/modal');

  const $modal = document.createElement('div');

  $modal.innerHTML = `
  <div id="modal_about_video" class="modal fade" data-bs-backdrop="true" data-bs-keyboard="true" aria-hidden="true" tabindex="-1">
    <div class="modal-dialog modal-xl text-dark modal-dialog-centered">
      <button type="button" class="close icon icon-close" data-bs-dismiss="modal">Close</button>

      <div class="modal-content">
        <div class="ratio ratio-16x9">
          <iframe src="${src}" class="embed-responsive-item" allowfullscreen />
        </div>
      </div>
    </div>
  </div>`;

  document.body.append($modal);

  const modal = new Modal(document.getElementById('modal_about_video'));

  modal._element.addEventListener('hidden.bs.modal', () => {
    $modal.remove();
  });

  if (state === 'show') {
    modal.show();
  } else {
    modal.hide();
  }
}

export { modalAboutVideo };
